import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { deepExtract } from 'helpers/deep';
import * as ObjectUtil from 'helpers/object';

export const Toggle = (props = {}) => (
  <label className={classNames('media', props.className)}>
    <input
      {...ObjectUtil.omit(['value'], props.input)}
      checked={deepExtract('input.value', props) ? 'checked' : ''}
      className="media__img"
      type="checkbox"
    />
    <span className="media__body">{props.label}</span>
  </label>
);

Toggle.propTypes = {
  className: PropTypes.string,
  input: PropTypes.object,
  label: PropTypes.node,
};
